module.exports = __webpack_public_path__ + "36386776b48526385edf2888192a4c0c.png";